<template>
  <div v-show="isEnterpriseAdminRenewSubscriptionModalVisible">
    <transition name="slide">
      <div class="modal-mask">
        <div class="modal-dialog modal-dialog-slideout modal-lg">
          <div class="modal-content p-2">
            <div class="modal-header">
              <div class="maheading_1">
                <i class="fa fa-chevron-left modal-goback" @click="close"></i>
              </div>
              <div class="maheading_2">
                <h5 class="modal-title">Renew subscription</h5>
              </div>
              <div class="maheading_3">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
              <form>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger"></div>
                </div>
                <div v-if="locations.length > 0">
                  <div class="account_heading">Select Accounts You Would Like to Renew Subscriptions for: </div>
                  <div class="res_offcanvas_header license_heading_1 text-left">
                    Account Name
                  </div>
                  <div class="res_offcanvas_header license_heading_4 text-center">
                    Unit Type
                  </div>
                  <div class="res_offcanvas_header license_heading_2 text-center">
                    Qty
                  </div>
                  <div class="res_offcanvas_header license_heading_3 text-center">
                    Price
                  </div>
                  <div class="clearfix"></div>
                  <div v-for="(item, index) in locations" :key="index">
                    <div class="res_offcanvas_content license_heading_1 text-left">
                      <input 
                        type="checkbox" 
                        :name="'assign_accounts_' + index"
                        :id="'assign_accounts_' + index"
                        :value="item.accId"
                        v-model="accountsSelected"
                        @click="setSubscriptionTotal(item, $event)">                            
                      <span class="overflow">{{ item.accountName }}</span>
                    </div>
                    <div class="res_offcanvas_content license_heading_4 text-center">
                      {{ item.unitType }}
                    </div>
                    <div class="res_offcanvas_content license_heading_2 text-center">
                      <input type="text" class="col-6" v-bind:name="'qty[' + index + ']'"
                      v-bind:id="'qty_' + index" 
                      v-model="item.qty"
                      readonly="true" >

                    </div>
                    <div class="res_offcanvas_content license_heading_3 text-center mt-2">
                      <label v-if="item.subscriptionPrice">
                        <span class="dollarsign">$</span>
                        <span>{{ item.subscriptionPrice }}/{{ item.validityDuration }} mo</span>
                      </label>
                      <label v-else>n/a</label>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="row row_data_border" v-if="accountsSelected.length > 0">
                    <div class="col-9 col-sm-9"></div>
                      <div class="col-3 col-sm-3 mt-2">
                        <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                          Total <span class="total_price">${{ subscriptionTotal }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-red text-center m-4">{{ getNoRecordText(locations.length) }}</div>
                  <div v-if="accountsSelected.length > 0">
                    <div class="row">
                      <div class="col-12">
                        <label class="form-label">Billing Information</label>
                        <div class="row">
                          <div class="col-12 col-sm-12">      
                            <input
                              type="text"
                              id="bname"
                              class="col-12 ma-input-field"
                              ref="bname"
                              name="bname"
                              v-model="billingName"
                              v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                              placeholder="Billing Name"
                              maxlength="250"
                              autocomplete="off"
                              :disabled="(isAccessPlan) ? false: true">
                            <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                            <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-12">
                            <b-form-select
                              class="col-12 ma-input-field"
                              id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                              :options="country_options"
                              v-on:change="getStateLists(billingCountry)"
                              :disabled="(isAccessPlan) ? false: true">
                            </b-form-select>
                            <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                          </div>
                          <div class="col-12 col-sm-12">
                            <input 
                              type="text" 
                              class="col-12 col-sm-12 ma-input-field" 
                              name="billing_address_1" 
                              placeholder="Billing Address 1" v-model="billingAddress" 
                              v-validate="'required'"
                              :disabled="(isAccessPlan) ? false: true">
                              <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                          </div>             

                          <div class="col-12 col-sm-12">
                            <input 
                              type="text" 
                              class="col-12 col-sm-12 ma-input-field" 
                              name="billing_address_2" 
                              placeholder="Billing Address 2" v-model="billingAddress2" 
                              :disabled="(isAccessPlan) ? false: true">
                            </div>                 

                            <div class="col-12 col-sm-12">
                              <input 
                                type="text" 
                                name="phone number" 
                                ref="phone_number"
                                v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                v-model="billingPhone"
                                @keyup="billingPhoneValid"
                                @blur="billingPhoneValid"
                                class="col-12 col-sm-12 ma-input-field" 
                                placeholder="Phone Number"
                                :disabled="(isAccessPlan) ? false: true">
                              <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-4 col-sm-4">
                              <input 
                                type="text" 
                                class="col-12 col-sm-12 ma-input-field" 
                                name="billing_city" 
                                placeholder="City" 
                                v-model="billingCity" 
                                v-validate="'required'"
                                :disabled="(isAccessPlan) ? false: true">
                                <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                              </div>
                              <div class="col-4 col-sm-4">
                                <b-form-select
                                  class="col-12 col-sm-12 ma-input-field"
                                  name="billing_state" v-model="billingState" v-validate="'required'"
                                  :options="state_options"
                                  :disabled="(isAccessPlan) ? false: true">
                                </b-form-select>    
                                <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                              </div>
                              <div class="col-4 col-sm-4">
                                <input 
                                  type="text" 
                                  name="zip code" 
                                  id="org_zip"
                                  ref="org_zip"
                                  v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                  v-model="billingZip"
                                  maxlength="10"
                                  class="col-12 col-sm-12 ma-input-field" 
                                  placeholder="Zip"
                                  :disabled="(isAccessPlan) ? false: true">
                                  <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-4">
                            <div class="col-12">
                              <label class="form-label">Credit/Debit Card Information</label>
                              <div class="row">
                                <div class="col-sm-12 col-md-12">
                                  <div class="row">
                                    <div class="col-sm-12 col-md-12">
                                      <input 
                                        type="text" 
                                        class="col-12 col-sm-12 ma-input-field" 
                                        name="card_no" 
                                        v-model="cardNumber"
                                        v-validate="'required'"
                                        placeholder="Credit Card #"
                                        :disabled="(isAccessPlan) ? false: true">
                                      <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-sm-12 col-md-12">
                                      <input 
                                        type="text" 
                                        class="col-12 col-sm-12 ma-input-field" 
                                        name="name_on_card" 
                                        v-model="nameOnCard"
                                        v-validate="'required'"
                                        placeholder="Name on Card"
                                        :disabled="(isAccessPlan) ? false: true">
                                        <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-4   col-sm-4">
                                        <select class="custom-select ma-input-field" name="exp_month" v-model="expMonth" v-validate="'required'" :disabled="(isAccessPlan) ? false: true">
                                          <option value="">Month</option>
                                          <option value="01">01</option>
                                          <option value="02">02</option>
                                          <option value="03">03</option>
                                          <option value="04">04</option>
                                          <option value="05">05</option>
                                          <option value="06">06</option>
                                          <option value="07">07</option>
                                          <option value="08">08</option>
                                          <option value="09">09</option>
                                          <option value="10">10</option>
                                          <option value="11">11</option>
                                          <option value="12">12</option>
                                        </select>
                                        <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                      </div>
                                      <div class="col-4 col-sm-4">
                                        <b-form-select
                                          class="custom-select ma-input-field"
                                          name="exp_year" 
                                          v-model="expYear" 
                                          v-validate="'required'"
                                          :options="year_options"
                                          :disabled="(isAccessPlan) ? false: true">
                                        </b-form-select>
                                        <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                      </div>
                                      <div class="col-4 col-sm-4">
                                        <input 
                                          type="password" 
                                          class="col-12 col-sm-12 ma-input-field" 
                                          name="cvv" 
                                          placeholder="CVV"
                                          v-model="cvvValue"v-validate="'required'"
                                          :disabled="(isAccessPlan) ? false: true" role="presentation"
                                          autoComplete="new-password">

                                          <div v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg">CVV is required</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-center m-2">
                                <button type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="onSubmit">
                                  Renew Subscription
                                </button>
                              </div>
                            </div>
                          </form>
              </div>
              <div class="modal-footer"></div>
              </div>
            </div>
          </div>
        </transition>

      <RenewAccountLicenseSuccessModal 
          :isRenewAccountLicenseSuccessModalVisible="isRenewAccountLicenseSuccessModalVisible"
          :accountId="accountsSelected"
          invoice_filename=""
          :accountName="selectedAccountNames"
          landingPage="enterpriseadminpurchasing"
          ref="renew_account_license_success"
          @close="close"
      />

      <RenewAccountLicenseFailedModal
          :isRenewAccountLicenseFailedModalVisible="isRenewAccountLicenseFailedModalVisible"
          landingPage="locations"
          @close="close"
      />

  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import RenewAccountLicenseSuccessModal from './renew_account_license_success_modal.vue';
import RenewAccountLicenseFailedModal from './renew_account_license_failed_modal.vue';

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isEnterpriseAdminRenewSubscriptionModalVisible', 'accountId'],
    data() {
        return {
            loading: false,
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            account_groups: '',
            account_groups_options: [],
            isActiveNewLocationModalVisible: false,
            isInactiveNewLocationModalVisible: false,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isRenewAccountLicenseSuccessModalVisible: false,
            locations: [],
            accountsSelected: [],
            selectedAccountNames: [],
            isRenewAccountLicenseFailedModalVisible: false,
        }
    },
    components: {
        RenewAccountLicenseSuccessModal,
        RenewAccountLicenseFailedModal,
    },
    methods: {
        close() {
            this.subscriptionTotal = 0;
            this.billingName = '';
            this.billingAddress = '';
            this.billingAddress2 = '';
            this.billingCity = '';
            this.billingState = '';
            this.billingCountry = '';
            this.billingZip = '';
            this.billingPhone = '';
            this.nameOnCard = '';
            this.cardNumber = '';
            this.expMonth = '';
            this.expYear = '';
            this.cvvValue = '';
            this.year_options = [];
            this.locations = [];
            this.accountsSelected = [];
            this.verrors.clear();
            this.$parent.closeEnterpriseAdminRenewSubscription();
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
        setSubscriptionTotal(item, event) {
            this.subscriptionId = item.subscriptionId;
            if (event.target.checked) {
                this.subscriptionTotal = this.subscriptionTotal + item.subscriptionPrice;
                this.selectedAccountNames.push(item.accountName);
            } else {
                this.subscriptionTotal = this.subscriptionTotal - item.subscriptionPrice;
                this.selectedAccountNames.splice(this.selectedAccountNames.indexOf(item.accountName), 1);
            }
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    this.processPayment();
                }
            });
        },
        processPayment() {
            this.loading = true;
            this.selected_accounts = [];
            for(var i=0; i<this.accountsSelected.length; i++) {
              for(var j=0; j<this.locations.length; j++) {
                if(this.accountsSelected[i] == this.locations[j].accId) {
                
                  this.selected_accounts.push(
                    {
                      "accId": this.locations[j].accId,
                      "subscriptionId": this.locations[j].subscriptionId,
                      "unit": this.locations[j].qty,
                      "price": this.locations[j].price,
                      "subscriptionPrice": this.locations[j].subscriptionPrice,
                    }
                  )
                }
              }
            }
            if(this.selected_accounts.length > 0) {
              axios('/enterprise-admin/renew-account-subscription', 
              {
                  method: 'POST',
                  data: {
                      "enterprise_id": this.accountId,
                      "selected_accounts": this.selected_accounts,
                      "billing_name": this.billingName,
                      "billing_address": this.billingAddress,
                      "billing_address2": this.billingAddress2,
                      "billing_city": this.billingCity,
                      "billing_state": this.billingState,
                      "billing_country": this.billingCountry,
                      "billing_zip": this.billingZip,
                      "billing_phone": this.billingPhone,
                      "payment_method": 'credit_card',
                      "name_oncard": this.nameOnCard,
                      "card_number": this.cardNumber,
                      "exp_month": this.expMonth,
                      "exp_year": this.expYear.toString().substr(-2),
                      "cvv_value": this.cvvValue,
                  },
              })
              .then((response) => {
                  this.loading = false;
                  this.verrors.clear();
                  if (response.data.order_msg != 'failed') {
                      this.isRenewAccountLicenseSuccessModalVisible = true;
                  } else {
                      this.isRenewAccountLicenseFailedModalVisible = true;
                  }
              })
              .catch(error => {
                  console.log(error)
              });
            }
        },
        getLinkedLocations() {
            this.loading = true;
            axios('/enterprise-admin/linked-locations-renew-subscriptions',
            {
                method: 'POST'
            })
            .then(response => {
                this.loading = false;
                this.locations = response.data.locations;
            })
            .catch(() => {
            });
        },
        loadInitialData() {
            this.verrors.clear();
            this.getCountryLists();
            this.getStateLists('US');
            this.getExpiryYears();
            this.getLinkedLocations();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
}
.totalBtn, .totalBtn:hover, .totalBtn:active, .totalBtn:focus {
  color: #002F42; 
  background-color: #FFF !important;
  border: 1px solid #002F42 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 10px;
  cursor: none;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 38px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.res_offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.res_offcanvas_content { float: left; margin: 5px 0; font-weight: 500; }
.row_data_border { border-top: 1px solid #ccc !important; }
.license_heading_1 { width: 35%; }
.license_heading_2 { width: 20%; }
.license_heading_3 { width: 23%; }
.license_heading_4 { width: 20%; margin-left: 5px; }
.planBtn, .planBtn:focus, .planBtn:active, .planBtn:hover {
  color: #000 !important;
  background: #a1ee95 !important;
  border: 1px solid #a1ee95 !important;
  border-radius: 5px;
  width: 100%;
}
.account_heading { text-decoration: underline; font-weight: 900; }
.overflow { word-wrap: break-word; } 
.loading_show { height: auto; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterpriseadmin_renew_subscription.vue